<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'
    >
      <wc-two-column-table :items='tableData'></wc-two-column-table>
      <v-card-text class='pt-0'>
        {{ snowEstimate.lawn_signs_note }}
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      @cancel='cancelEdit'
      @save='saveEdit'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-row dense>
          <v-col cols='12' md='6'>
            <wc-datepicker :max='estimateCopy.end_date' v-model='estimateCopy.start_date' label='Start date'></wc-datepicker>
          </v-col>
          <v-col cols='12' md='6'>
            <wc-datepicker :min='estimateCopy.start_date' v-model='estimateCopy.end_date' label='End date'></wc-datepicker>
          </v-col>
          <v-col cols='12'>
            <v-select
              label='Billing type'
              :items='billingTypes'
              v-model='snowEstimateCopy.billing_type'
            ></v-select>
            <v-checkbox hide-details v-model='snowEstimateCopy.do_on_christmas' label='Do on Christmas?'></v-checkbox>
            <v-checkbox persistent-hint v-model='snowEstimateCopy.is_quickpay' label='Quick pay?' hint='Adds $40 to monthly base price'></v-checkbox>
            <v-checkbox persistent-hint v-model='snowEstimateCopy.ice_melt_ok' label='Rock Chip Selected?' hint='Adds $40 to monthly base price'></v-checkbox>
            <v-checkbox persistent-hint v-model='snowEstimateCopy.lawn_signs_ok' label='Lawn sign?' hint='Adds $5 discount to monthly base price'></v-checkbox>
            <v-textarea class='mt-9' outlined v-model='snowEstimateCopy.lawn_signs_note' label='Lawn signs note'></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'snow-estimate-details',
  props: {
    estimate: {
      required: true
    },
    snowEstimate: {
      required: true
    }
  },
  data: () => ({
    title: 'Details',
    icon: 'mdi-view-list',
    iconColor: 'orange',
    isFormValid: false,
    showDialog: false,
    label: 'grey--text',
    estimateCopy: {},
    snowEstimateCopy: {}
  }),
  computed: {
    tableData () {
      return [
        { text: 'Service start date', value: this.estimate.start_date ? this.$options.filters.shortDate(this.estimate.start_date) : 'Not set' },
        { text: 'Service end date', value: this.estimate.end_date ? this.$options.filters.shortDate(this.estimate.end_date) : 'Not set' },
        { text: 'Billing Type', value: this.snowEstimate.billing_type_display },
        { text: 'Do on Christmas?', value: this.$options.filters.trueFalse(this.snowEstimate.do_on_christmas) },
        { text: 'Quick pay?', value: this.$options.filters.trueFalse(this.snowEstimate.is_quickpay) },
        // { text: 'Confirmation sent?', value: this.$options.filters.trueFalse(this.snowEstimate.confirmation_sent) },
        // { text: 'Thank you email?', value: this.$options.filters.trueFalse(this.snowEstimate.thank_you_email) },
        { text: 'Rock Chip Selected?', value: this.$options.filters.trueFalse(this.snowEstimate.ice_melt_ok) },
        { text: 'Lawn signs?', value: this.$options.filters.trueFalse(this.snowEstimate.lawn_signs_ok) },
        { text: 'Lawn signs note:', value: this.snowEstimate.note }
      ]
    },
    billingTypes () {
      return this.$store.state.misc.globalOptions.snowBillingTypes
    }
  },
  methods: {
    openEdit () {
      this.snowEstimateCopy = _.cloneDeep(this.snowEstimate)
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    saveEdit () {
      this.$emit('updateDetail', this.snowEstimateCopy)
      this.$emit('update', this.estimateCopy)
      this.cancelEdit()
    }
  }
}
</script>
